<template>
  <div
    class="auth-language-switcher"
    :class="{ 'auth-language-switcher--dark': dark }"
  >
    <v-select
      v-model="selectedLocale"
      :items="languageItems"
      item-text="label"
      item-value="value"
      dense
      outlined
      hide-details
      single-line
      class="auth-language-switcher__select"
      :dark="dark"
      :aria-label="$t('register.step2.language')"
      @input="onLocaleInput"
    >
      <template v-slot:selection="{ item }">
        <country-flag :country="getCountryCode(item.value)" class="mb-0 mr-1" />
        <span>{{ item.label }}</span>
      </template>
      <template v-slot:item="{ item }">
        <country-flag :country="getCountryCode(item.value)" class="mb-0 mr-2" />
        <span class="text-subtitle-2">{{ item.label }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import services from '@/services'
import { changeAuthLocale } from '@/utils/helpers'
import CountryFlag from 'vue-country-flag'

export default {
  name: 'AuthLanguageSwitcher',
  components: { CountryFlag },
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedLocale: '',
      availableLocales: []
    }
  },
  computed: {
    languageItems () {
      return this.availableLocales.map((value) => ({
        value,
        label: this.$t(`languages.${value}`)
      }))
    }
  },
  async created () {
    await this.fetchLanguages()
    const picked = this.pickLocale(this.availableLocales)
    this.selectedLocale = picked
    changeAuthLocale(picked)
  },
  methods: {
    async fetchLanguages () {
      try {
        const { data } = await services.get('Frontend/GetAvailableLanguages')
        this.availableLocales = Array.isArray(data) ? data : []
      } catch (e) {
        this.availableLocales = ['en-US', 'pl-PL']
      }
    },
    pickLocale (available) {
      if (!available.length) {
        return 'en-US'
      }
      const saved = localStorage.getItem('lang')
      if (saved && available.includes(saved)) {
        return saved
      }
      const candidates = [...(navigator.languages || []), navigator.language].filter(Boolean)
      for (const c of candidates) {
        if (available.includes(c)) {
          return c
        }
        const prefix = c.split('-')[0]
        const match = available.find(
          (a) => a === prefix || a.startsWith(`${prefix}-`)
        )
        if (match) {
          return match
        }
      }
      if (available.includes('en-US')) {
        return 'en-US'
      }
      return available[0]
    },
    onLocaleInput (value) {
      if (value) {
        changeAuthLocale(value)
      }
    },
    getCountryCode (locale) {
      return (locale || '').split('-')[1] || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-language-switcher__select {
  max-width: 160px;
  min-width: 130px;
}

.auth-language-switcher--dark {
  ::v-deep .v-input__slot fieldset {
    border-color: rgba(255, 255, 255, 0.7) !important;
  }
}
</style>
